import { render, staticRenderFns } from "./LandArea.vue?vue&type=template&id=249c6675&"
import script from "./LandArea.vue?vue&type=script&lang=ts&"
export * from "./LandArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports